export const ORG_STATUS = {
  WAITING_FOR_REVIEW: 0, // 리뷰 대기
  IN_REVIEW: 1, // 리뷰중
  REJECTED: 2, // 거부
  REMOVED: 3, // 제거됨
  ASSOCIATE_MEMBER: 4, // 준회원
  REGULAR_MEMBER: 5, // 정회원
}

export const ORG_STATUS_STRING = [
  '심사대기',
  '심사중',
  '거부',
  '제거됨',
  '준회원',
  '정회원'
]
